import { post } from '../api.service';

export const calculateInvoiceAmount = async (payload: []) => {
    return await post('/Calculator/invoicecalculations-api', payload);
};

export const calculateGrossSalary = async (payload: []) => {
    return await post('/Calculator/gross-amount-calculation', payload);
};
export const calculateNetSalary = async (payload: []) => {
    return await post('/Calculator/net-amount-calculation', payload);
};
